import { JSXInternal } from 'preact/src/jsx';
import { Content } from './Content';
import { ContentService } from '../../ContentService';
import { Container } from '../shared/Container';
import { PrivacyFooter } from '../shared/PrivacyFooter';
import { ActionButtons } from '../shared/Buttons/ActionButtons';

export const PreferencesPanel = () => (
  <Container sectionId={'consent-preferences'}>
    <Content />
    <PrivacyFooter>
      <ActionButtons rejectId="ccmgt_preferences_reject" acceptId="ccmgt_preferences_accept" />
    </PrivacyFooter>
  </Container>
);

export const RenderPreferencesPanel = async (): Promise<() => JSXInternal.Element> => {
  await ContentService.FetchActiveLanguage();
  return PreferencesPanel;
};
